<template>
    <div>
        <div class="hidden at1024:flex relative h-fit items-center justify-start">
            <div
                :class="{
                    [classes]: classes,
                }"
                class="relative overflow-hidden truncate">
                <span @mouseover="showHint = true" @mouseleave="showHint = false">{{ value }}</span>
            </div>
            <Transition name="fade-top" class="-ml-2">
                <button-tooltip
                    v-if="showHint"
                    :text="value"
                    side="top"
                />
            </Transition>
        </div>
        <div class="block at1024:hidden">{{ value }}</div>
    </div>
</template>

<script setup>
import {ButtonTooltip} from "@/Components";
import {ref} from "vue";

const props = defineProps({
    value: {
        type: String,
        required: false,
        default: "—",
    },
    classes: {
        type: String,
        required: false,
        default: "max-w-[150px] min-w-[150px]",
    },
});

const showHint = ref(false);
</script>
